'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useClosetAuth } from '@/contexts/ClosetAuthContext';
import { fetchOutfits } from '@/lib/closet/api-client';
import type { Outfit } from '@/types/closet';
import { hasTimelineMedia } from '@/lib/closet/timeline-media';
import { Overlay } from './Overlay';
import { MediaReview } from './MediaReview';
async function refreshDrafts() {
  return fetchOutfits().catch(() => null);
}
export function OutfitDrafts(t0) {
  const $ = _c(13);
  const {
    outfits,
    onUpdate
  } = t0;
  const {
    isAuthenticated
  } = useClosetAuth();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  let t1;
  if ($[0] !== onUpdate) {
    t1 = async function refresh() {
      const current = await refreshDrafts();
      setError(current ? "" : "Could not refresh outfits");
      current?.forEach(onUpdate);
    };
    $[0] = onUpdate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const refresh = t1;
  if (!isAuthenticated) {
    return null;
  }
  let t2;
  if ($[2] !== refresh) {
    t2 = <button type="button" aria-label="Review unpublished outfits" onClick={() => {
      setOpen(true);
      refresh();
    }}>✎</button>;
    $[2] = refresh;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== error || $[5] !== onUpdate || $[6] !== open || $[7] !== outfits || $[8] !== refresh) {
    t3 = open && <Overlay label="Unpublished outfits" onClose={() => setOpen(false)}><h2>Unpublished outfits</h2><button type="button" className="lookbook-button" onClick={() => void refresh()}>Refresh</button>{error && <p role="status">{error}</p>}<div className="outfit-drafts">{outfits.flatMap(outfit => !hasTimelineMedia(outfit) || outfit.mediaCandidate ? [<div key={outfit.id}><span>{outfit.name}</span><MediaReview outfit={outfit} onUpdate={onUpdate} /></div>] : [])}</div></Overlay>;
    $[4] = error;
    $[5] = onUpdate;
    $[6] = open;
    $[7] = outfits;
    $[8] = refresh;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}